export default __webpack_public_path__ + "static/media/site-e-commerce.e2e8bf4e.png";